export default {"src":"/_next/static/media/img_marketbom_section2_4.b5a78dcc.svg","height":188,"width":320,"blurWidth":0,"blurHeight":0};